<script setup lang="ts">
import { Switch } from "@/components/ui/switch";
import { computed } from "vue";
import { cn } from "@/lib/utils";
import { Grip } from "lucide-vue-next";

const props = defineProps<{
    eventType: any;
    dragDisabled: boolean;
    enabled: boolean;
}>();

const emit = defineEmits(["toggleAttachment"]);

const enabled = computed({
    get() {
        return props.enabled;
    },
    set() {
        emit("toggleAttachment", props.eventType);
    },
});
</script>

<template>
    <div :class="cn('flex justify-between rounded-md bg-iron-50 px-4 py-2')">
        <div class="flex items-center gap-3">
            <Grip
                v-if="!dragDisabled"
                class="event-card-handle w-4 cursor-move"
            />
            <div v-else class="w-4" />
            <p class="text-sm font-medium">
                {{ eventType.name }}
            </p>
        </div>

        <Switch v-model:checked="enabled" />
    </div>
</template>
